import { useCallback, useEffect } from 'react';
import useOnboardingProcess from '@hooks/useOnboardingProcess';
import { useAuth } from '@hooks/useAuth';
import wait from '@helpers/wait';
import { useResponsive } from '@hooks/useResponsive';

export default function useMediaViewerReviewAudioVideoTour({
  isAssetReady,
  isAudio,
  isPreparing,
  isUnsupported,
  setSelectedCollapse
}: {
  isAssetReady: boolean;
  isAudio: boolean;
  isPreparing: boolean;
  isUnsupported: boolean;
  setSelectedCollapse?: (collapse: string | null) => void;
}) {
  const user = useAuth(false);
  const { isLgWidth } = useResponsive();
  const { onStartTour, tourData, onCompleteStep } = useOnboardingProcess();
  const completedOnboardingSteps = user?.user?.completedOnboardingSteps || [];

  const onStartTimeRangeFeedback = useCallback(async () => {
    setSelectedCollapse?.('comments');
    await wait(500);
    onStartTour({
      type: 'review-audio-video',
      onClickNext: (_currentStep, isExitTour) => {
        if (isExitTour) {
          onCompleteStep({ type: 'review-audio-video', hideCongrats: true });
        }
      },
      onClickPrev: (_currentStep, isExitTour) => {
        if (isExitTour) {
          onCompleteStep({ type: 'review-audio-video', hideCongrats: true });
        }
      }
    });
  }, [onStartTour, onCompleteStep]);

  useEffect(() => {
    if (!isLgWidth) return;
    if (user?.user?.type !== 'internal') return;
    if (tourData?.type) return;
    if (completedOnboardingSteps.includes('review-audio-video')) return;
    if (!isAudio || isUnsupported) return;
    if (isPreparing) return;
    if (!isAssetReady) return;
    onStartTimeRangeFeedback();
  }, [
    isAssetReady,
    isAudio,
    isPreparing,
    isUnsupported,
    user?.user?.type,
    completedOnboardingSteps,
    tourData?.type,
    onStartTimeRangeFeedback,
    isLgWidth
  ]);

  return null;
}
